export default "__VITE_ASSET__DNx4NNUr__"